
<div v-if="data">
  <div class="card card-gallery">
    <div class="card-content is-relative px-0 py-0">
      <!-- <a @click="showModal = true"> -->
        <div v-show="loading" class="loading-overlay">
          <div class="loader"></div>
        </div>
        <figure v-if="large" class="thumbnail-image image">
          <img :src="large" @load="loading = false" />
        </figure>
      <!-- </a> -->
    </div>
  </div>
  <div v-if="data.thumbnail.length > 1" class="columns is-multiline is-centered is-mobile mt-2">
    <a v-for="(photo, index) in data.thumbnail" :key="index" @click="show(index)" class="column is-3">
      <figure class="thumbnail-image image has-background-white p-1 is-rounded">
        <img :src="photo" />
      </figure>
    </a>
  </div>
  <!-- <modal v-if="showModal" @close="showModal = false">
    <div slot="body" class="is-relative">
      <div v-show="loading" class="loading-overlay">
        <div class="loader"></div>
      </div>
      <figure class="image">
        <img :src="large" @load="loading = false" />
      </figure>
    </div>
  </modal> -->
</div>
